/* eslint-disable camelcase */
import { formatMonthFromMillis } from '@/filter/date';
import { DateTime } from 'luxon';

export const identnummer = {
  key: 'werkzeugnummer',
  sortable: true,
  label: 'Identnummer',
  tdClass: 'py-1',
};

export const kategorie = {
  key: 'werkzeuggruppe',
  sortable: true,
  label: 'Kategorie',
  tdClass: 'py-1',
  formatter: (value) => value?.full_name || '',
  sortKey: 'wg.full_name',
};

export const kaufdatum = {
  key: 'kaufdatum',
  sortable: true,
  label: 'Kaufdatum',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const standort = {
  key: 'aktueller_standort',
  sortable: true,
  label: 'Standort',
  sortKey: 'a_standort.full_name',
  tdClass: 'py-1',
  formatter: (value) => value?.full_name,
};

export const risikobewertung_risiko = {
  key: 'risikobewertung_risiko',
  sortable: true,
  label: 'Risikobewertung',
  sortKey: 'IFNULL(w.risikobewertung_risiko, 99)',
  tdClass: 'py-1',
  formatter: (value) => {
    if (value === null || value === undefined) return '';
    switch (value) {
      case 0:
        return 'Niedrig';
      case 1:
        return 'Mittel';
      case 2:
        return 'Hoch';
      default:
        return '';
    }
  },
};

export const status = {
  key: 'werkzeugstatus',
  sortable: true,
  sortKey: 'ws.name',
  label: 'Status',
  tdClass: 'py-1',
  formatter: (value) => {
    if (!value) return '';
    return value?.name || '';
  },
};

export const benutzer = {
  key: 'benutzer',
  sortable: true,
  label: 'Benutzer',
  tdClass: 'py-1',
};

export const seriennummer = {
  key: 'seriennummer',
  sortable: true,
  label: 'Seriennummer',
  tdClass: 'py-1',
};

export const baujahr = {
  key: 'baujahr',
  sortable: true,
  label: 'Baujahr',
  tdClass: 'py-1',
};

export const name = {
  key: 'beschreibung',
  sortable: true,
  sortKey: 'w.beschreibung',
  label: 'Name',
  tdClass: 'py-1',
};

export const letzteWartung = {
  key: 'letzte_wartung',
  sortable: true,
  label: 'Letzte Wartung',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const letztePruefung = {
  key: 'letzte_pruefung',
  sortable: true,
  label: 'Letzte Prüfung',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const pruefintervall = {
  key: 'pruefintervall',
  sortable: true,
  label: 'Prüfintervall',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return `${val} Monate`;
    return '';
  },
};

// export const wartungsintervall = {
//   key: 'wartungsintervall',
//   sortable: true,
//   label: 'Wartungsintervall',
//   tdClass: 'py-1',
//   formatter: (val) => {
//     if (val) return `${val} Monate`;
//     return '';
//   },
// };

export const naechstePruefungWartung = {
  key: 'naechste_pruefung_wartung',
  sortable: false,
  label: 'Nächste Prüfung/Wartung',
  formatter: (value) => {
    if (!value) return '';
    return formatMonthFromMillis(value);
  },
  tdClass: (value) => {
    if (value) {
      const month = DateTime.fromMillis(value).startOf('month');
      const actualMonth = DateTime.now().startOf('month');
      const nextMonth = DateTime.now().plus({ month: 1 }).startOf('month');

      if (month.ts < actualMonth.ts) {
        return 'py-1 text-danger font-weight-bold alert-danger';
      } if (month.ts === actualMonth.ts) {
        return 'py-1 font-weight-bold alert-warning';
      } if (month.ts === nextMonth.ts) {
        return 'py-1 font-weight-bold alert-info';
      }
    }
    return 'py-1';
  },
};

export const naechstePruefungWartungName = {
  key: 'naechste_pruefung_wartung_name',
  sortable: false,
  label: 'Prüfung/Wartung',
};

const abteilung = {
  key: 'abteilung',
  sortable: true,
  label: 'Abteilung',
  tdClass: 'py-1',
  formatter: (value) => value?.titel || '',
};

export const kostenstelle = {
  key: 'kostenstelle',
  sortable: true,
  label: 'Kostenstelle',
  tdClass: 'py-1',
};

export const hersteller = {
  key: 'hersteller',
  sortable: true,
  label: 'Hersteller',
  tdClass: 'py-1',
};

export const maschinennummer_intern = {
  key: 'maschinennummer_intern',
  sortable: true,
  label: 'Maschinennummer (intern)',
  tdClass: 'py-1',
};

export const stellplatznummer = {
  key: 'stellplatznummer',
  sortable: true,
  label: 'Stellplatznummer',
  tdClass: 'py-1',
};

export default {
  stammliste: [
    identnummer,
    name,
    kategorie,
    standort,
  ],
  possibleFields: [
    seriennummer,
    benutzer,
    baujahr,
    name,
    status,
    hersteller,
    kaufdatum,
    risikobewertung_risiko,
    abteilung,
    kostenstelle,
    maschinennummer_intern,
    stellplatznummer,
    letzteWartung,
    letztePruefung,
  ],
  pruefungWartungFields: [
    naechstePruefungWartungName,
    naechstePruefungWartung,
  ],
};
